export const version = 'kunde-v1.20.0-SNAPSHOT-d1ada48d4cc3fa3bf12970639957a75ca4531521';